import { sdk } from 'src/utilities/sdk';
import { Employee, CreateEmployeeResponse } from 'src/types/Employee';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';

export const getEmployeeCreateEndpoint = (corpId: string): string =>
  `/corp-admin/${corpId}/diners`;

export function createEmployee(
  corpId: string,
  employeeData: Employee
): Promise<CreateEmployeeResponse> {
  const decamelizedCorpData = decamelizeRequestBody(
    employeeData
  ) as unknown as Employee;

  return sdk.http.post(getEmployeeCreateEndpoint(corpId), decamelizedCorpData);
}
